import { Categorie } from './Categorie';
export class Documento {
  id: number;
  descrizione: string;
  old: boolean;
  revisione: string;
  categorie;//: number[] | string[] | Categorie[];
  file: string;
  allegato;
  Categorie?: Categorie[];
  date?:string;
  constructor() {
    this.old = false;
  }
}
